import {cookieConfig} from '@/configs/cookie.config';
import {cookieHelper} from '@/helpers/cookie.helper';
import type {User, UserCredentials, UserWithToken} from '@/types/user';
import {computed, ref} from '@vue/reactivity';
import {defineStore} from 'pinia';

export const useAuthStore = defineStore('auth', () => {
    const user = ref<User | null>(null);
    const accessToken = ref<string | null>(null);
    const refreshToken = ref<string | null>(null);
    const isLoggedIn = computed(() => !!user.value);

    const setAllToken = (info: UserCredentials) => {
        accessToken.value = info.token;
        // refreshToken.value = info.refreshToken;
    };

    const logout = () => {
        user.value = null;
        accessToken.value = null;
        cookieHelper.remove(cookieConfig.user.name);
    };

    const login = (userInfo: any) => {
        const userInfoMapped = mapUserInfo(userInfo);
        user.value = {
            id: userInfoMapped.id,
            source_id: userInfoMapped.source_id,
            name: userInfoMapped.name,
            email: userInfoMapped.email,
        };
        if (userInfoMapped.token) {
            accessToken.value = userInfoMapped.token;
            // refreshToken.value = userInfoMapped.refreshToken;
            const userCredentials: UserCredentials = {
                token: userInfoMapped.token,
                // refreshToken: userInfoMapped.refreshToken
            };
            cookieHelper.set(cookieConfig.user.name, JSON.stringify(userCredentials), cookieConfig.user.days);
        }
    };

    const mapUserInfo = (userInfo: any): UserWithToken => {
        return {
            id: userInfo.id,
            source_id: userInfo.source_id,
            name: userInfo.name,
            email: userInfo.email,
            token: userInfo.token || null,
            refreshToken: userInfo.refreshToken || null
        };
    };

    return {
        user,
        accessToken,
        refreshToken,
        isLoggedIn,
        logout,
        login,
        setAllToken
    };
});
